import { TranslateService } from '@ngx-translate/core';
import * as Domain from '@core/Domain';

export class DomainIit {

  static Init(translateService: TranslateService) {
const domain_LocalResourcesDefinition = new Domain.Domain_LocalResourcesDefinition(translateService);
const globalResourcesDefinition = new Domain.GlobalResourcesDefinition(translateService);
const reportRow = new Domain.ReportRow(translateService);
const companyInfo = new Domain.CompanyInfo(translateService);
const dashobard = new Domain.Dashobard(translateService);
const productAnalysisDTO = new Domain.ProductAnalysisDTO(translateService);
const productAnalysisItemDTO = new Domain.ProductAnalysisItemDTO(translateService);
const productAnalysisFilters = new Domain.ProductAnalysisFilters(translateService);
const yearAnalysis = new Domain.YearAnalysis(translateService);
const project = new Domain.Project(translateService);
const payment = new Domain.Payment(translateService);
const comment = new Domain.Comment(translateService);
const product = new Domain.Product(translateService);
const projectDocument = new Domain.ProjectDocument(translateService);
const resourceUtilization = new Domain.ResourceUtilization(translateService);
const projectCostAnalysisItem = new Domain.ProjectCostAnalysisItem(translateService);
const costCenter = new Domain.CostCenter(translateService);
const subproduct = new Domain.Subproduct(translateService);
const invoice = new Domain.Invoice(translateService);
const invoiceLine = new Domain.InvoiceLine(translateService);
const company = new Domain.Company(translateService);
const client = new Domain.Client(translateService);
const currency = new Domain.Currency(translateService);
const bankAccount = new Domain.BankAccount(translateService);
const fiscalYear = new Domain.FiscalYear(translateService);
const companyInvoiceInfo = new Domain.CompanyInvoiceInfo(translateService);
const clientContact = new Domain.ClientContact(translateService);
const companyTaxRule = new Domain.CompanyTaxRule(translateService);
const taxRuleScaleItem = new Domain.TaxRuleScaleItem(translateService);
const employee = new Domain.Employee(translateService);
const employeeRate = new Domain.EmployeeRate(translateService);
const monthyReport = new Domain.MonthyReport(translateService);
const monthlyReportLine = new Domain.MonthlyReportLine(translateService);
const taskEntry = new Domain.TaskEntry(translateService);
const pMOUser = new Domain.PMOUser(translateService);
const expenseRule = new Domain.ExpenseRule(translateService);
const expense = new Domain.Expense(translateService);
const expsenseCategory = new Domain.ExpsenseCategory(translateService);
const menuItem = new Domain.MenuItem(translateService);
const lead = new Domain.Lead(translateService);
const leadType = new Domain.LeadType(translateService);
const leadStatus = new Domain.LeadStatus(translateService);
const leadProductLine = new Domain.LeadProductLine(translateService);
const leadJournalEntry = new Domain.LeadJournalEntry(translateService);
const leadTypeDynamicField = new Domain.LeadTypeDynamicField(translateService);
const leadDynamicFieldValue = new Domain.LeadDynamicFieldValue(translateService);
const leadStatusActivationValidation = new Domain.LeadStatusActivationValidation(translateService);
const leadTerminalAction = new Domain.LeadTerminalAction(translateService);
const leadUpload = new Domain.LeadUpload(translateService);
const leadAutomation = new Domain.LeadAutomation(translateService);
const leadAutomationAction = new Domain.LeadAutomationAction(translateService);
const leadActionExecution = new Domain.LeadActionExecution(translateService);
const leadAutomationEnpointActionResponseHandling = new Domain.LeadAutomationEnpointActionResponseHandling(translateService);
const leadAutomationResult = new Domain.LeadAutomationResult(translateService);
const dynamicField = new Domain.DynamicField(translateService);
const dynamicFieldGroup = new Domain.DynamicFieldGroup(translateService);
const dynamicFieldOption = new Domain.DynamicFieldOption(translateService);
const dynamicFieldConditionLine = new Domain.DynamicFieldConditionLine(translateService);
const dynamiFieldGroupDTO = new Domain.DynamiFieldGroupDTO(translateService);
const dynamiFieldGroupItemDTO = new Domain.DynamiFieldGroupItemDTO(translateService);
const leadFilters = new Domain.LeadFilters(translateService);
const leadActionType = new Domain.LeadActionType(translateService);
const leadAction = new Domain.LeadAction(translateService);
const tagCategory = new Domain.TagCategory(translateService);
const tag = new Domain.Tag(translateService);
const tagConditionLine = new Domain.TagConditionLine(translateService);
const marketSegment = new Domain.MarketSegment(translateService);
const cRMStats = new Domain.CRMStats(translateService);
const cRMStatsItem = new Domain.CRMStatsItem(translateService);
const cRMStatsInfoByUser = new Domain.CRMStatsInfoByUser(translateService);
const notification = new Domain.Notification(translateService);
const interationDTO = new Domain.InterationDTO(translateService);
const interactionCustomFieldValueDTO = new Domain.InteractionCustomFieldValueDTO(translateService);
const accountDTO = new Domain.AccountDTO(translateService);
const dynamicServiceIntegration = new Domain.DynamicServiceIntegration(translateService);
const dynamicServiceEndpoint = new Domain.DynamicServiceEndpoint(translateService);
const emailHelper = new Domain.EmailHelper(translateService);
const email = new Domain.Email(translateService);
const notificationWorkflow = new Domain.NotificationWorkflow(translateService);
const notificationWorkflowStep = new Domain.NotificationWorkflowStep(translateService);
const applicationUserAction = new Domain.ApplicationUserAction(translateService);
const applicationUserExternalProfile = new Domain.ApplicationUserExternalProfile(translateService);
const applicationSetting = new Domain.ApplicationSetting(translateService);
const applicationUser = new Domain.ApplicationUser(translateService);
const applicationRole = new Domain.ApplicationRole(translateService);
const applicationOperation = new Domain.ApplicationOperation(translateService);
const applicationPermission = new Domain.ApplicationPermission(translateService);
const applicationClient = new Domain.ApplicationClient(translateService);
const applicationUserLogin = new Domain.ApplicationUserLogin(translateService);
const applicationUserClaim = new Domain.ApplicationUserClaim(translateService);
const profileSetting = new Domain.ProfileSetting(translateService);
const profile = new Domain.Profile(translateService);
const applicationLanguage = new Domain.ApplicationLanguage(translateService);
const applicationTimezoneInfo = new Domain.ApplicationTimezoneInfo(translateService);
const dateTimeFormat = new Domain.DateTimeFormat(translateService);
const applicationTheme = new Domain.ApplicationTheme(translateService);
const fileData = new Domain.FileData(translateService);
const auditEntityConfiguration = new Domain.AuditEntityConfiguration(translateService);
const auditPropertyConfiguration = new Domain.AuditPropertyConfiguration(translateService);
const auditLogEntry = new Domain.AuditLogEntry(translateService);
const auditLogEntryType = new Domain.AuditLogEntryType(translateService);
const auditLogPropertyActionType = new Domain.AuditLogPropertyActionType(translateService);
const workflowExecutionResult = new Domain.WorkflowExecutionResult(translateService);
const workflowContextBase = new Domain.WorkflowContextBase(translateService);
const workflowSchedule = new Domain.WorkflowSchedule(translateService);
const sendTaskRemindersContext = new Domain.SendTaskRemindersContext(translateService);
const periodicDataUpdateContext = new Domain.PeriodicDataUpdateContext(translateService);
 }

}
